<template>
  <div class="details">
    <!-- 菜单导航 -->
    <Menu></Menu>
    <div class="main-wrapper-content main_content" style="width:1200px;margin:0 auto">
      <div class="details_context">
        <div class="breadcrumb_box">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/circle' }">社区</el-breadcrumb-item>
            <el-breadcrumb-item>详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="text_deta">
          <div class="list-img-box">
            <div class="list-flex">
              <div class="less-than-four-content">
                <div class="user-content">
                  <div class="user-content_div">
                    <div class="head-image-box">
                      <img :src="listdata.avatar_url" />
                    </div>
                    <div class="user-content-bottom">
                      <p>{{ listdata.nickname }}</p>
                      <p>{{ listdata.create_time }}</p>
                    </div>
                    <div id="follow-hover-btn-box">
                      <!-- <div class="follow-btn">关注</div> -->
                    </div>
                  </div>
                  <div class="page-detail-card" style="text-align:left;">
                    {{ listdata.content }}
                  </div>
                  <div class="user_img">
                    <div class="thumb-example" v-show="listdata.image.length > 0">
                      <swiper :options="swiperOptionTop" class="gallery-top imgs" ref="swiperTop">
                        <swiper-slide class="slide-1 imgsList" :controls="1" v-for="item in listdata.image"
                          :key="index">
                          <img :src="item.url" width="100%" @click="toDetails(item.id)">
                        </swiper-slide>
                      </swiper>
                      <!-- swiper2 Thumbs -->
                      <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
                        <swiper-slide class="slide-1" :controls="1" v-for="item in listdata.image" :key="index">
                          <img :src="item.url" alt="">
                        </swiper-slide>
                      </swiper>
                    </div>
                    <div v-if="listdata.media" v-for="item in listdata.media" :key="index">
                      <video-player class="video-player vjs-custom-skin" ref="videoPlayer"
                        v-for="(items, i) in playerOptions" :key="i" :options="items">
                      </video-player>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div class="img-tag">
              <div class="college-tag" v-if="listdata.tag">
                <div v-for="(item, i) in listdata.tag" :key="i">{{item}}</div>
              </div>
              <div class="img-tag-right">
                <div class="praise-box" :class="listdata.is_like == true?'confirm':''" @click="likeClick()">
                  <span class="iconfont icon-zan"></span>
                  <span>{{ likeNum }}</span>
                </div>
                <div class="collect-box" :class="listdata.is_collect == true?'confirm':''" @click="scClick()">
                  <span class="iconfont icon-shoucang"></span>
                  <span>{{ listdata.is_collect?'已收藏':'收藏' }}</span>
                </div>
              </div>
            </div>
            <div class="lines"></div>
          </div>
        </div>
        <div class="inMyBox">
          <el-input type="textarea" placeholder="请输入内容" v-model="myIputText" class="myteare"></el-input>
        </div>
        <div class="my_pinglunbox">
          <el-button :disabled="myIputText == '' ? submissionFlag = true : submissionFlag = false"
            :class="myIputText == '' ? '' : 'hoverButton'" @click="myInputClick">评论
          </el-button>
        </div>
        <div class="the-tabs">
          <ul class="heads">
            <li class="active">
              <span class="tab-name">评论</span><!-- <span class="tab-count">18</span> -->
            </li>
          </ul>
          <div class="lines" style="left: 0px;"></div>
          <div class="tab-body">
            <div class="commentList" v-if="listdata.read.id">
              <div class="li">
                <div class="left"> <img :src="listdata.read.thumb">
                  <div class="tittle">
                    <div class="userinfo-box">{{ listdata.read.name }}
                      <el-tag style="margin-left:10px;" size="mini" type="success">讲师点评</el-tag>
                    </div>
                    <div>{{ listdata.read.create_time }}</div>
                  </div>
                </div>
              </div>
              <div class="content-box">
                <audio ref="audio" :src="listdata.read.audio" controls class="comment-media"></audio>
                <div class="content">
                  <p>{{ listdata.read.content }}</p>
                </div>
              </div>
            </div>
            <div class="commentList" v-for="(items,index) in commentData" :key="index">
              <div class="li">
                <div class="left"> <img :src="items.avatar_url">
                  <div class="tittle">
                    <div class="userinfo-box">{{ items.nickname }}</div>
                    <div>{{ items.create_time }}</div>
                  </div>
                </div>
                <!-- <div class="icon-box">
                  <div class="comment-box"><img src="@/assets/circle/img15.png" alt="" @click="otherShowClick"></div>
                  <div class="thumb-box" @click="dzClick"><img :src="dzanurl" alt="">
                    <span>{{ dzannum }}</span>
                  </div>
                </div> -->
              </div>
              <div class="content-box">
                <div class="content">
                  <p>{{ items.content }}</p>
                  <div class="inMyBox" v-if="otherIputShow" style="margin-top:15px;">
                    <el-input type="textarea" placeholder="请输入内容" v-model="IputTextOther" class="myteare">
                    </el-input>
                  </div>
                  <div class="my_pinglunbox" v-if="otherIputShow">
                    <el-button
                      :disabled="IputTextOther == '' ? submissionFlagOther = true : submissionFlagOther = false"
                      :class="IputTextOther == '' ? '' : 'hoverButton'" @click="InputClick">评论
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="loading-page">
              <div class="empty-btn" v-if="this.pageMax == 0 ||this.page == this.pageMax">没有更多了</div>
              <div class="empty-btn" @click="showComment()" v-else>点击展开更多</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部链接 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import {
    swiper,
    swiperSlide
  } from "vue-awesome-swiper"
  import "swiper/dist/css/swiper.css";
  import Menu from '@/components/view/Menu'
  import Footer from '@/components/view/Footer'
  export default {
    name: "critdetials",
    components: {
      Menu,
      Footer,
      swiper,
      swiperSlide
    },
    data() {
      return {
        listdata: {
          image: [],
          media: []
        },
        swiperOptionTop: {
          effect: "fade",
          orderType: 0,
          spaceBetween: 10,
          pagination: 'page',
          paginationType: 'fraction'
        },
        swiperOptionThumbs: {
          spaceBetween: 30,
          centeredSlides: true,
          slidesPerView: 'auto',
          touchRatio: 0.2,
          slideToClickedSlide: true,
          loop: true,
        },
        playerOptions: [],
        commentData: [], //评论数据
        submissionFlag: true,
        IputTextOther: "",
        submissionFlagOther: true,
        otherIputShow: false,
        myIputText: "",
        likeNum: 0,
        page: 1,
        pageMax: 1, // 评论最大页码
      }
    },
    mounted() {
      this.$nextTick(() => {
        const swiperTop = this.$refs.swiperTop.swiper
        const swiperThumbs = this.$refs.swiperThumbs.swiper
        swiperTop.controller.control = swiperThumbs
        swiperThumbs.controller.control = swiperTop
      })
    },
    created() {
      this.getlist()
      this.commentList()
    },
    methods: {

      // 查看更多评论
      showComment() {
        this.page += 1
        this.commentList()
      },
      // 获取评论
      commentList() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/comment/listData', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token'),
          },
          data: {
            type: 2,
            type_id: this.$route.query.id,
            limit: 10,
            page: this.page
          }
        }).then(res => {
          for (var i = 0; i < res.data.data.data.length; i++) {
            this.commentData.push(res.data.data.data[i])
          }
          this.pageMax = res.data.data.last_page
        })
      },
      myInputClick() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/comment/create', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token'),
          },
          data: {
            type: 2,
            type_id: this.$route.query.id,
            content: this.myIputText
          }
        }).then(res => {
          if (res.data.code == 200) {
            this.$message.success(res.data.msg)
          } else {
            this.$message({
              message: res.data.msg
            });
          }
        })
      },
      otherShowClick() {
        if (this.otherIputShow) {
          this.otherIputShow = false
        } else {
          this.otherIputShow = true
        }
      },
      getlist() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/post/detail', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token'),
          },
          data: {
            "id": this.$route.query.id
          }
        }).then(res => {
          this.listdata = res.data.data
          this.likeNum = res.data.data.like_nums;
          for (let x = 0; x < this.listdata.media.length; x++) {
            const element = this.listdata.media[x].url;
            let arrstrr = {
              playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
              autoplay: false, // 如果为true,浏览器准备好时开始回放
              muted: false, // 默认情况下将会消除任何音频。
              loop: false, // 是否视频一结束就重新开始。
              preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
              language: 'zh-CN',
              aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
              fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
              sources: [{
                type: "video/mp4", // 类型
                src: element // url地址
              }],
              poster: '', // 封面地址
              notSupportedMessage: '此视频暂无法播放，请稍后再试'
            }
            this.playerOptions.push(arrstrr)
          }
        }).catch(err => {
          console.log(err)
        })
      },
      likeClick() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/user/likeThis', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token'),
          },
          data: {
            type: 1,
            type_id: this.$route.query.id
          }
        }).then(res => {
          if (res.data.code == 200) {
            var status = this.listdata.is_like;
            this.listdata.is_like = !status
            if (status == true) {
              this.likeNum -= 1
            } else {
              this.likeNum += 1
            }
          }
        })
      },
      scClick() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/user/collectThis', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token'),
          },
          data: {
            type: 1,
            type_id: this.$route.query.id
          }
        }).then(res => {
          if (res.data.code == 200) {
            var status = this.listdata.is_collect;
            this.listdata.is_collect = !status
          }
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .comment-media {
     height:32px;
     margin:10px 0;
  }

  .imgList {
    width: 450px;
    height: 100px;
    margin-top: 20px;
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
  }

  .imgListShow {
    flex-shrink: 0;
    width: 100px;
    height: 100%;
    float: left;
    margin-right: 10px;
    border: 2px solid #ccc;
    box-sizing: border-box;
  }

  .imgListShow.active {
    border: 2px solid #1989FA;
  }

  .imgListShow img {
    display: block;
    width: 100%;
    height: 100%;
  }

  .imgs {
    width: 780px;
    height: 500px;
    border-radius: 20px;
  }

  .imgsList {
    width: 100%;
    height: 100%;
  }

  .imgsList img {
    display: block;
    width: 100%;
    height: 100%;
  }

  .gallery-thumbs {
    height: 20% !important;
    box-sizing: border-box;
    padding: 10px 0;
  }

  .gallery-thumbs .swiper-slide {
    width: 100px;
    height: 100px;
    opacity: 0.4;
  }

  .gallery-thumbs .swiper-slide img {
    display: block;
    width: 100px;
    height: 80px;
    border-radius: 10px;
  }

  .gallery-thumbs .swiper-slide-active {
    opacity: 1;
  }

  .gallery-thumbs .swiper-slide-active img {
    border: 2px solid #FABE00;
  }

  //用来改变按钮的颜色
  .swiper-button-prev {
    width: 36px;
    height: 36px;
    background-position: 50%;
    cursor: pointer;
    background-size: 36px;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAC2klEQVRYR82Yz4tSURTHvz6iph8TNNUsZIyJ58soiNb5J7RUcVcEIc7gOBuXLiIJJALX/sBliAQxhLSZhSv3FcWkr6LJwUVRVGNGjBbfh0+cN0/nPt8zPLvLu+fcz7vnnHvOvS5Yl6MATgM4BWAOAMdS30wPwB8AvwHsAvjRHwuv4hKeCZwBcB7ASQCien8BtAF8BvBNZC0Rw/MAPP3dELE5ag537ROAn+OMjAPiN4Kcs0NhovulD8bdOyCjgI4AkPvucZhHM0c3vgOwZzRuBkSYSw646LAfoQvrRigjEMeEYeD+D+FOEWrgPiPQBSdiplqt3lxcXPTE4/HHm5ubTP1xwpja1icMAzGbFLvboqrquizLt2hnZ2fn2dLS0j0Bmw09+4aBrtiNm2EYQjSbzQ2Px3NfAIjx9IbzdCAeehcFFEdOMcK02+16OByOViqV74J2P/Dw1IEYyCwFE0mj0Vj3er2am7Sctg5DNZaaOoFYi65aKAf7oFVVjcuyfNsmDNWZaa8JxJOY2WVZ6vV6XFEUJ2D0tbcJtAxgwSrNFGCI8JVAlwGcsAI0JRgi/CLQNQAsF0KytbUV8/l8dxyIGbP19gh0fajBGguVTCaXU6nUEz0BOp3O+1AodNdCah/20z1LQKFQ6GypVNqQJOk4LXe73XahUFiLRqMvDltJ8LsGZMll5XL5RjAYfORyuY7pUMViMRaJRF4KLjpumuYyy0FtBpXP52MrKyt2obSgnijtpwSlpf3EB+MUoLSD0VbpMEL1er3dXC63NoH7BqWDQWaruJpBZbPZ2Orq6isLgT4ortSx3X6YQWUymUgikXgrCLWv/aCO7QbNCNVqtZ673e6kANCBBo06jrSwhAoEAg8lSZqr1WoP/H7/UwEg0xaWeo40+YFAYEFRlPl0Ov1RAGZkk0/dmbsGEWqmLor6Ds/UVVqHmqnHhuFYnJnnGGOCzMyDlRFsqk96/wCAGUG0M6i27QAAAABJRU5ErkJggg==);
  }

  .swiper-button-next {
    width: 36px;
    height: 36px;
    background-position: 50%;
    cursor: pointer;
    background-size: 36px;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAC3UlEQVRYR82Yz4tSURTHv+NEZNZEUQvRfqtJ0dTalQs3McQQhEjLwR9rIUIIo4VLNzniiAQxsxN12Z9g/0GB80aKUVxYTdD0Y4rhGd/He2LqG+/TW3h3791zz/28c84957y7AOvjOIAlAKcAnADAZ5uuRgXwG8ABgG8AvurPwrssCEsCZwFcAOAAILquB+A7gI8AvojsJaL4NICLujVEdJrJ0GotAPtHKTkKiHMEOT8LxZi1n3QwWm9kmAEdA3Bdd49kHk0d3dgEcDisfBwQYXwSXDTpQ+jC7WGoYSA+E4aB+z8GLUWovvuGgS5NiplQKLSUy+UedbvdVjAYfC2BmjG1a+gZBOJp8k7aoN1uP3e5XPcp12w2tzwez4tJawTmFeP0DQLdFImbVqv1zO12rxqbSIJiPL2jTgOISe+qwJdgZWXlTLlcLjocDsaaNiRBvWfyNIConKVAaIyD2tnZ2fJ6vbO4j6Vmm0CsRbcslAMN2sRSmx6PJyf0VaNCPGlvCcRMzNNleYyDUhRl0+fzTQu1S6ArAM5ZptEXSIbaI5AfwMlpgczcN6WlfhBoGQDLxUxjnKUajcYrv9+ft6D4kEB3BxosC2tHRQlVqVRe2u32a/psL51OP8xkMh8EFatSgYrF4p1oNLq+uLio1UJVVX9GIpHVSqXy2QqQFJeVSqXltbW1vAHT6/V+VavVx+Fw+I0gDMU0l80c1BsbG8uxWGxWGAJpQT3TsZcIQyDt2E+dGCXDEEhLjFOVDsLE4/F1m82m1cApY2YwvPqlgy8tFddCoXA7kUjkJcKQoV9c+SDcfmSz2RvJZLIkGYYMf7UffCHUoHU6nYzT6bwnyU2Gy0YaNE4ItbD1ev1BIBB4qqrqQa1We2Ixz5ilpLEtLIUnNvkUSqVSlxVF2a/VansWkp6ZqGmTzwVz9xtEqLn6UTTMOle/0gbUXF02DAbg3FzHDJ+KubmwGgb7p1d6fwDN8C60Z5NJmgAAAABJRU5ErkJggg==);
  }

  .tab-body .tittle {
    color: #a3a8ab;
    font-size: 12px;
  }

  .commentList {
    border-bottom: 1px solid #f0f0f0;
    padding: 15px;
  }

  .loading-page {
    margin-top: 30px;
  }

  .userinfo-box {
    font-size: 15px;
  }

  .content-box {
    margin-top: 8px;

    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 400;
    color: #18252c;
    line-height: 20px;
    word-wrap: break-word;
    word-break: break-word;
  }

  .details {
    .details_context {
      width: 780px;

      .text_deta {
        /deep/ .el-carousel__button {
          background-color: #000;
        }

        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        width: 100%;


        .list-img-box {
          margin-top: 31px;
          margin-bottom: 20px;
          width: 100%;

          .list-flex {
            position: relative;
            display: flex;
          }
        }
      }

      .video_box {
        width: 100%;
        padding: 15px;

        .video-player {
          width: 400px;
          height: 250px;
        }

        /deep/ .vjs-custom-skin>.video-js .vjs-big-play-button {
          background-color: rgba(0, 0, 0, 0.45);
          font-size: 2.5em;
          width: 4rem;
          height: -7em !important;
          margin-top: -1em !important;
        }

        /deep/.vjs-custom-skin>.video-js .vjs-big-play-button {
          top: 50%;
          left: 50%;
          margin-left: -1.5em;
          margin-top: -1em;
        }
      }

      .inMyBox {
        margin-bottom: 20px;

        /deep/ .el-textarea__inner {
          &:focus {
            width: 100%;
            min-height: 117px;
            background: #fff;
            border-radius: 10px;
            caret-color: #FABE00;
          }

          min-height: 117px;
          background: #f7f7f7;
          border-radius: 10px;
          border: 1px solid #dcdcdc;
          padding: 14px 16px 16px;
          font-size: 14px;
          font-family: PingFangSC-Medium,
          PingFang SC,
          Helvetica,
          STHeiti,
          Microsoft YaHei,
          "sans-serif";
          font-weight: 500;
          color: #18252c;
          line-height: 20px;
        }
      }

      .my_pinglunbox {
        display: flex;
        justify-content: flex-end;

        .hoverButton {
          opacity: 1 !important;
        }

        /deep/ .el-button {
          background: #FABE00;
          display: inline-block;
          width: 112px;
          height: 36px;
          line-height: 12px;
          border-radius: 27px;
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
          font-weight: 600;
          color: #fff;
          text-align: center;
          cursor: pointer;
        }
      }

      .the-tabs {
        .tab-body {
          .commentList {
            margin-top: 15px;
            width: 100%;

            .li {
              display: flex;
              width: 100%;
              align-items: center;
              justify-content: space-between;

              .left {
                display: flex;

                img {
                  height: 40px;
                  width: 40px;
                  border-radius: 50%;
                  overflow: hidden;
                }

                .tittle {
                  text-align: left;
                  margin-left: 10px;
                }
              }

              .icon-box {
                display: flex;

                .comment-box {
                  margin-right: 20px;

                  img {
                    width: 20px;
                    height: 20px;
                  }
                }

                .thumb-box {
                  margin-right: 30px;

                  img {
                    width: 20px;
                    height: 20px;

                  }
                }
              }
            }

            .content-box {
              text-align: left;
              margin: 10px 52px;
            }
          }

          .empty-btn,
          .loading-btn {
            width: 100%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: #fff8f1;
            border-radius: 6px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
            font-weight: 400;
            color: #f80;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
          }
        }
      }
    }
  }
</style>
<style scoped>
  .the-tabs .heads {
    display: flex;
  }

  .the-tabs .heads>:first-child {
    margin-left: 0;
  }

  .the-tabs .heads>li .tab-count,
  .the-tabs .heads>li {
    font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 400;
  }

  .the-tabs .heads>li {
    font-size: 20px;
    color: #a3a8ab;
    line-height: 28px;
    margin-left: 60px;
    cursor: pointer;
    z-index: 10;
  }

  .the-tabs .lines {
    z-index: 5;
    width: 46px;
    height: 6px;
    background: #FABE00;
    position: relative;
    top: -6px;
    transition: all .3s;
  }


  .less-than-four-content {
    flex: 1;
    margin-left: 12px;
    position: relative;
    cursor: pointer;
  }

  .user-content_div {
    display: flex;
    margin-bottom: 20px;
  }

  .user-comment {
    height: 25px;
  }

  .page-detail-card {
    margin: 20px 0 16px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 600;
    color: #18252c;
    line-height: 22px;
  }

  .page-detail-card-star {
    float: left;
    width: 80px;
    height: 24px;
    margin-right: 4px;
  }

  .card-work-link {
    padding: 0 32px 0 26px;
    display: table-caption;
    height: 24px;
    line-height: 24px;
    background: #e6f7ee;
    border-radius: 12px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 400;
    color: #FABE00;
    cursor: pointer;
    position: relative;
  }

  .work-link-icon {
    position: absolute;
    display: inline-block;
    transform: translateY(-50%);
    top: 50%;
    left: 8px;
    width: 14px;
    height: 14px;
    background: url('~@/assets/circle/img12.png') 100% 100% no-repeat;
  }

  .work-link-to-icon {
    position: absolute;
    display: inline-block;
    transform: translateY(-50%);
    top: 50%;
    right: 8px;
    width: 12px;
    height: 12px;
    background: url('~@/assets/circle/img13.png') 100% 100% no-repeat;
  }

  .card-work-link-msg {
    max-width: 637px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  #follow-hover-btn-box {
    display: flex;
    margin-left: auto;
    margin-top: 6px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  #follow-hover-btn-box .follow-btn {
    width: 59px;
    height: 28px;
    background: #e6f7ee;
    border-radius: 14px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 500;
    color: #FABE00;
    line-height: 28px;
    text-align: center;
  }

  .user-content-bottom {
    margin-left: 8px;
    text-align: left;
  }

  .user-content-bottom p:first-child {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 600;
    color: #18252c;
    line-height: 20px;
  }

  .user-content-bottom p:last-child {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 400;
    color: #9fa4a7;
    line-height: 17px;
    margin-top: 2px;
    cursor: auto;
    text-align: left;
  }

  .head-image-box img {
    height: 40px;
    width: 40px;
    border-radius: 50%;
  }

  .play-btn {
    position: absolute;
    top: 68px;
    left: 15%;
    transform: translateX(-50%);
    width: 60px;
    text-align: center;
  }

  .less-than-four-img {
    position: relative;
    width: 260px;
    height: 195px;
    overflow: hidden;
    border-radius: 5px;
    cursor: pointer;
  }

  .less-than-four-img img,
  .play-btn img {
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
  }

  .img-tag {
    display: flex;
    justify-content: flex-start;
    margin-top: 12px;
  }

  .college-tag div {
    float: left;
    margin-right: 5px;
    padding: 0 9px;
    height: 24px;
    background: oldlace;
    border-radius: 12px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 400;
    color: #FABE00;
    line-height: 24px;
    text-align: center;
    cursor: auto;
  }

  .college-tag-courseType {
    margin-left: 8px;
  }

  .img-tag-right {
    display: flex;
    margin-left: auto;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 500;
    color: #747c80;
  }

  .img-tag-right .iconfont {
    font-size: 22px !important;
    margin-right: 5px;
  }

  .img-tag-right .confirm .icon-zan {
    color: #FD6D64
  }

  .img-tag-right .confirm .icon-shoucang {
    color: #FABE00
  }

  .collect-box {
    box-sizing: border-box;
    width: 74px;
    display: flex;
    line-height: 25px;

  }

  .lines {
    width: 100%;
    height: 1px;
    background: #e6e6e6;
    border-radius: 9px;
    margin-top: 20px;
  }

  .praise-box {
    width: 74px;
    display: flex;
    line-height: 25px;
  }

  .comment-box {
    display: flex;
    align-items: center;
    width: 74px;
    cursor: pointer;
  }

  .img-tag .img-tag-right img {
    width: 24px;
    vertical-align: text-bottom;
    margin-right: 4px;
  }

  .comment-box span {
    font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-size: 12px;
    font-weight: 500;
    color: #747c80;
  }

  .share__wrap {
    position: relative;
  }

  .share_box {
    display: flex;
    align-items: center;
    width: 74px;
    height: 100%;
    cursor: pointer;
  }

  .share__icon {
    display: inline-block;
    width: 24px;
    height: 24px;
    vertical-align: middle;
    transition: background .2s ease-in-out;
    background: url('~@/assets/circle/img14.png') 100% 100% no-repeat;
    background-size: 100%;
    margin-right: 4px;
  }

  .share__label {
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 500;
    color: #747c80;
    line-height: 16px;
  }

  /**circle-right */
  .circle-right {
    height: inherit;
    margin-left: 15px;
  }

  .advertising-list {
    width: 247px;
    font-size: 0;
  }

  .recommend-course-box {
    display: flex;
    width: 247px;
    background: #fff;
    box-shadow: 0 0 6px 0 rgb(0 0 0 / 5%);
    border-radius: 8px;
    align-items: center;
    flex-direction: column;
    padding-bottom: 20px;
    margin-top: 24px;
  }

  .title-box {
    width: 100%;
    height: 58px;
    background-image: url('~@/assets/circle/img22.png');
    background-size: 100%;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333;
    line-height: 22px;
    padding-left: 16px;
    box-sizing: border-box;
  }

  .course-item {
    box-sizing: border-box;
    width: 215px;
    margin-bottom: 24px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    position: relative;
    cursor: pointer;
  }

  .course-cover {
    position: relative;
    font-size: 0;
  }

  /* .course-state-name :before{
          position: absolute;
          width: 215px;
          height: 42px;
          background: linear-gradient(1turn,rgba(0,0,0,.6),transparent);
          left: 0;
          bottom: 0;
          content: "";
          display: block;
          border-radius: 0 0 6px 6px;
        } */
  .course-cover>.unstart {
    padding: 3px 8px 3px 0;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #fff;
    background: rgba(14, 14, 14, .62);
    border-radius: 15px;
    display: inline-block;
  }

  .course-state {
    position: absolute;
    top: 8px;
    left: 8px;
  }

  .unstart-tip {
    margin-right: 6px;
    background: #44d7b6;
    border-radius: 20px;
    color: #18252c;
    padding: 4px 8px;
  }

  .course-image {
    width: 100%;
    height: 142px;
    border-radius: 8px 8px 8px 8px;
    overflow: hidden;
  }

  .course-state-name {
    position: absolute !important;
    bottom: 8px !important;
    left: 10px !important;
  }

  .courseName {
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #fff;
    line-height: 14px;
    font-size: 14px;
    text-shadow: 0 1px 2px rgb(0 0 0 / 30%);
  }

  /* .el-tab-pane{display: flex;} */
  .btn-box {
    width: 247px;
    height: 216px;
    background: #f5f8f8;
    border-radius: 8px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .user-box {
    position: relative;
    z-index: 99;

  }

  .btn-box-item {
    cursor: pointer;
    font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-size: 12px;
    text-align: center;
    width: 45%;
    margin-top: 10px;
  }

  .btn-box-item img {
    width: 60px;
    height: 60px;
  }

  .btn-box-item p {
    line-height: 17px;
    margin-top: 5px;
  }

  .course-item>h4 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 16px 0 10px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #18252c;
    text-align: left;
  }

  .course-teacher {
    display: flex;
    align-items: center;
  }

  .course-teacher img {
    width: 20px;
    height: 20px;
    margin: 0 4px 0 0;
    border-radius: 10px;
  }

  .course-teacher-nickname {
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #747c80;
    line-height: 20px;
  }

  .total-student {
    margin-left: auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .bottom-box {
    height: 32px;
    background: #fafafa;
    border-radius: 4px;
    width: 215px;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #747c80;
    line-height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .circle-flex {
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/CircleDetails.vue